export default __webpack_public_path__ + "static/media/teams-1.e28dbc6e.jpg";